module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-section"
  }, [(_vm.placeholder_list) ? [_vm._l((_vm.placeholder_list), function(item, index) {
    return (index < 2) ? _c('div', {
      key: index,
      staticClass: "cb-placeholder__section"
    }, [_c('cb-placeholder', {
      attrs: {
        "custom-class": 'sm'
      }
    }), _vm._v(" "), _c('cb-placeholder', {
      attrs: {
        "custom-class": 'sm rect-sm'
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.placeholder_list >= 3) ? _c('div', {
    staticClass: "cb-placeholder__section"
  }, [_c('cb-placeholder', {
    staticClass: "cb-placeholder__center",
    attrs: {
      "custom-class": 'sm rect-md'
    }
  })], 1) : _vm._e()] : _c('div', _vm._l(((1, 2)), function(i) {
    return _c('div', {
      key: i,
      staticClass: "cb-placeholder__section"
    }, [_c('cb-placeholder', {
      attrs: {
        "custom-class": 'sm'
      }
    }), _vm._v(" "), _c('cb-placeholder', {
      attrs: {
        "custom-class": 'sm rect-sm'
      }
    })], 1)
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-016a3ad6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/portal/PortalLoader.vue
// module id = 636
// module chunks = 84